export var checkObjectIsNotEmpty = function (object) {
    return Boolean(Object.values(object).find(function (x) { return (Array.isArray(x) ? !!x.length : !!x); }));
};
